import React from "react";

export const prepareTags = (tags) => {
	if (tags === null || tags === undefined) {
		return null;
	}
	const tagsLength = tags.length;

	const tagList = tags.map((tag, index) => {
		if (index < tagsLength - 1) {
			return (
				<React.Fragment key={`${tag}-${index}`}>
					<span>#{tag},</span>{" "}
				</React.Fragment>
			);
		} else {
			return <span key={`${tag}-${index}`}>#{tag}</span>;
		}
	});

	return tagList;
};

export const filterBlogs = (blogs, filter) => {
	if (filter === "Saved") {
		return blogs.filter(b => b.isSaved);
	}

	return blogs;
}

export const sortBlogs = (blogs, sortValue) => {
	// default
	// newest
	// most_liked

	if (sortValue === "newest") {
		blogs.sort((b1, b2) => new Date(b2.createdAt) - new Date(b1.createdAt));
	}
	else if (sortValue === "most_liked") {
		blogs.sort((b1, b2) => b2.likes - b1.likes);
	}
}